module.exports = __webpack_public_path__ + "img/pf.7d005ae1.svg";